import { FieldReviewTable } from "../fieldReviewTable";

export interface UwHudReviewTableProps {
  data: Record<string, any>;
}

export const UwHudReviewTable = ({ data }: UwHudReviewTableProps) => {
  return <FieldReviewTable items={data?.items} />;
};
